/**
 * Select a Job
 * Slight differences from Launch/SelectJob
 */
// @todo: Migrate to 'Dialog.Alert' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Alert} from '@wandb/weave/components/Alert';
// @todo: Migrate to 'Select' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Select} from '@wandb/weave/components/Form/Select';
import React from 'react';

import * as S from '../../SelectComponents.styles';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {useAvailableProjectJobOptions} from '../hooks';
import {JobOption} from './types';

interface SelectJobProps {
  entityName: string | undefined;
  projectName: string | undefined;
  selectedJobId: JobOption | null;
  defaultJobStr?: string;
  filterStr?: string;
  disabled?: boolean;
  onSelectJob: (job: JobOption) => void;
}

export type JobInfo = {
  jobName: string;
  jobVersion: string;
  jobProject?: string;
};

const OptionLabel = (props: JobOption) => {
  return (
    <S.SelectOptionLabel>
      <S.SelectOptionLabelText>{props.label}</S.SelectOptionLabelText>
    </S.SelectOptionLabel>
  );
};

export const SelectJob = ({
  entityName,
  projectName,
  selectedJobId,
  defaultJobStr,
  filterStr,
  disabled,
  onSelectJob,
}: SelectJobProps) => {
  const {jobOptions, loading} = useAvailableProjectJobOptions(
    entityName ?? '',
    projectName ?? ''
  );
  let options = jobOptions;
  // Filter options by filterStr
  if (filterStr) {
    options = options.filter(option => {
      return option.label.toLowerCase().includes(filterStr.toLowerCase());
    });
  }

  if (options.length === 0 && !loading) {
    return <Alert severity="info">There are no jobs in this project yet</Alert>;
  }

  // On some pages we might not know the job id, just str
  if (defaultJobStr != null && selectedJobId == null) {
    const foundDefault = options.find(x => x.label === defaultJobStr);
    if (foundDefault != null) {
      onSelectJob(foundDefault);
    }
  }

  const onChange = (option: JobOption | null) => {
    if (option) {
      onSelectJob(option);
    }
  };
  return (
    <Select
      isLoading={loading}
      options={options}
      placeholder="Select a job..."
      onChange={onChange}
      value={selectedJobId as any}
      formatOptionLabel={OptionLabel}
      isDisabled={disabled}
    />
  );
};
